var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var StyledDisclaimers = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 4rem 2rem;\n  width: 100%;\n  background-color: ", ";\n  p {\n    max-width: 1440px;\n    margin: 0 auto;\n    font-size: 0.8rem;\n    line-height: 1.5rem;\n    color: ", ";\n  }\n  a {\n    color: ", ";\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n  @media (max-width: 600px) {\n    padding: 2rem 1rem;\n  }\n"], ["\n  padding: 4rem 2rem;\n  width: 100%;\n  background-color: ", ";\n  p {\n    max-width: 1440px;\n    margin: 0 auto;\n    font-size: 0.8rem;\n    line-height: 1.5rem;\n    color: ", ";\n  }\n  a {\n    color: ", ";\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n  @media (max-width: 600px) {\n    padding: 2rem 1rem;\n  }\n"])), function (_a) {
    var $bgColor = _a.$bgColor;
    return $bgColor || 'unset';
}, function (_a) {
    var $textColor = _a.$textColor;
    return $textColor || 'inherit';
}, function (_a) {
    var $textColor = _a.$textColor;
    return $textColor || 'inherit';
});
var templateObject_1;
